import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from '../common/Footer';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
}


const Layout: React.FC<LayoutProps> = ({ children }) => {
  // State for mobile open/close
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // State for desktop collapsed/expanded
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  // Mobile toggle
  const toggleSidebar = () => setSidebarOpen((open) => !open);
  const closeSidebar = () => setSidebarOpen(false);

  // Desktop collapse toggle
  const toggleSidebarCollapse = () => setSidebarCollapsed((collapsed) => !collapsed);

  return (
    <div className={styles.layoutContainer}>
      <Header onMenuClick={toggleSidebar} />
      <div className={`${styles.mainWrapper} ${sidebarCollapsed ? styles.collapsed : ''} row w-100 m-0`}>
        <div className="col-12 d-flex p-0">
          <div className={`sidebar-col ${sidebarCollapsed ? 'collapsed' : ''}`}>
            <Sidebar
              isOpen={sidebarOpen}
              onClose={closeSidebar}
              isCollapsed={sidebarCollapsed}
              onCollapseToggle={toggleSidebarCollapse}
            />
          </div>
          <div className={`col-10 main-content-col py-3 ${sidebarCollapsed ? 'expanded' : ''}`}>
            <main className={styles.contentArea}>{children}</main>
          </div>
        </div>
      </div>
      {isLoginPage && <Footer />}
    </div>
  );
};

export default Layout;